import { Modal, Box, Typography, Button, IconButton, CircularProgress } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  blue,
  green,
  orange,
  pink,
  purple,
  red,
  yellow,
} from "@mui/material/colors";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
interface SecureModalProps {
  open: boolean;
  onClose: () => void;
  token: string | null;
  lotteryId: string | null;
  offset:any
}
interface AvailableBallsResponse {
  message: string;
  data: number[];
}
const useStyles = makeStyles((theme) => ({
  ballContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: theme.spacing(1),
  },
  cardContent: {
    position: "relative",
    padding: theme.spacing(2),
  },
  ballRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing(1.5),
  },
  ball: {
    width: 35,
    height: 35,
    fontSize: 11,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    borderRadius: "50%",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
    margin: theme.spacing(-0.5),
    backgroundImage: (props: any) =>
      `linear-gradient(135deg, ${props.color} 30%, ${props.colorDark} 90%)`,
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.9)",
    },
  },
  selectedBall: {
    transform: "scale(2.0)",
    border: "2px solid white",
    "@media screen and (max-width:992px)": {
      transform: "scale(1.5)",
    },
  },
  ballText: {
    marginTop: theme.spacing(1),
    fontSize: 12,
  },

  checkboxLabel: {
    fontSize: "12px",
    color: "#ffffff",
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
      fill: "#ffffff",
    },
    "& .MuiTypography-body1": {
      fontSize: "12px",
    },
  },
}));

const BaiscModal: React.FC<SecureModalProps> = ({
  open,
  onClose,
  token,
  lotteryId,
  offset
}) => {
  console.log(token, "token abhay");
  const [selectedBall, setSelectedBall] = useState<number[]>([]);;
  const [jackpotSelected, setJackpotSelected] = useState(false);
  const [postBallApi, setPostBallApi] = useState({});
  const [availableBalls, setAvailableBalls] = useState<AvailableBallsResponse>({
    message: "",
    data: [],
  });
  const [loader, setLoader] = useState(true);
  console.log(availableBalls?.data, "availableBalls");
  const navigate = useNavigate();
const handleBallClick = (number) => {
  setSelectedBall((prevSelected) => {
    if (prevSelected.includes(number)) {
      // if already selected → remove it
      return prevSelected.filter((n) => n !== number);
    } else {
      // if not selected → only add if limit not reached
      if (prevSelected.length < offset) {
        return [...prevSelected, number];
      } else {
        // limit reached → don't change
        return prevSelected;
      }
    }
  });
};

console.log(selectedBall,"selectedBall");

  const classes = useStyles({});

  const colors = [
    { light: yellow[700], dark: yellow[900] },
    { light: blue[700], dark: blue[900] },
    { light: red[700], dark: red[900] },
    { light: pink[900], dark: pink[800] },
    { light: orange[700], dark: orange[900] },
    { light: green[700], dark: green[900] },
    { light: purple[700], dark: purple[900] },
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true)
        const response = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/available-ball`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params: {
              lotteryId: lotteryId,
            },
          }
        );
        //  response&& setLoader(false)
        console.log("API Response:", response.data);
        setAvailableBalls(response.data);
      
      } catch (error: any) {
        toast.error("Link got expired");
        
      }finally {
        setTimeout(() => setLoader(false), 500); // Small delay ensures smooth transition
      }
    };
    fetchData();
  }, [lotteryId, token]);
  const Ball = ({ number, color, colorDark, isSelected, onClick }) => {
    const ballStyles = useStyles({});

    return (
      <Box display="flex" flexDirection="column" alignItems="center" margin={1}>
        <Box
          className={`${ballStyles.ball} ${
            isSelected ? ballStyles.selectedBall : ""
          }`}
          style={{ backgroundColor: isSelected ? colorDark : color }}
          onClick={() => onClick(number)}
        >
          {number}
        </Box>
      </Box>
    );
  };

  const BallRow = ({ selectedBall, onBallClick, availableBalls }) => {
    return (
      <Box className={useStyles({}).ballRow}>
        {availableBalls &&
          availableBalls?.data?.map((ballNumber, index) => (
            <Ball
              key={index}
              number={ballNumber}
              color={colors[ballNumber - 1]?.light}
              colorDark={colors[ballNumber - 1]?.dark}
            isSelected={selectedBall.includes(ballNumber)}
             onClick={() => onBallClick(ballNumber)} 
            />
          ))}
      </Box>
    );
  };
  const submitSelectedBall = async () => {
    console.log(selectedBall, "selectedBall Abhay");
    if (selectedBall.length==0) {
      toast.error("Please select a ball before submitting.");
      return;
    }

    try {
      const response = await axios.put(
        `${process.env.API_URL_PREFIX}/api/v1/user/updateBall`,
        { ballColor: selectedBall },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Ball submitted successfully!");
      console.log("API Response:", response.data);
      setPostBallApi(response.data);
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(error.response.data.message || "Invalid request!");
        } else {
          toast.error("An unexpected error occurred. Please try again.");
        }
      } else {
        toast.error("Network error. Please check your connection.");
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableEscapeKeyDown
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      BackdropProps={{
        onClick: (event) => event.stopPropagation(),
      }}
    >
      {availableBalls?.data?.length ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "#0B0417",
            color: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 3,
            textAlign: "center",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 50, color: "#6D27F9" }} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <HourglassEmptyIcon
              sx={{ color: "#F6B932", fontSize: 30, mr: 1 }}
            />
            <Typography sx={{ color: "#F6B932" }}>
              Please Select your balls{" "}
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ mt: 2 }}>
            Please Select your balls
          </Typography>
          {loader ? (
      <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
        <CircularProgress sx={{ color: "#F6B932" }} />
      </Box>
    ) : (
      availableBalls?.data?.length ? (
        <BallRow
          selectedBall={selectedBall}
          onBallClick={handleBallClick}
          availableBalls={availableBalls}
        />
      ) : (
        <Typography>No available balls</Typography>
      )
    )}

          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#6D27F9",
              width: "100%",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#5C1EC3" },
            }}
            onClick={submitSelectedBall}
          >
            Submit
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "#0B0417",
            color: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 3,
            textAlign: "center",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 50, color: "#6D27F9" }} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <HourglassEmptyIcon
              sx={{ color: "#F6B932", fontSize: 30, mr: 1 }}
            />
            <Typography sx={{ color: "#F6B932" }}>Link got expired </Typography>
          </Box>
        </Box>
      )}
    </Modal>
  );
};

export default BaiscModal;
